<script setup>
// Inline contextual-help control. Drop next to any feature:
//   <HelpHint slug="connect-telegram" title="Connect Telegram" />
// Renders a small "?" (or a labelled link) that opens the help drawer.
import { useMesselloHelp } from 'dashboard/composables/useMesselloHelp';

const props = defineProps({
  slug: { type: String, required: true },
  title: { type: String, default: '' },
  label: { type: String, default: '' },
});

const { openHelp } = useMesselloHelp();
</script>

<template>
  <button
    v-if="label"
    type="button"
    class="mz-hint mz-hint-link"
    @click="openHelp(slug, title)"
  >
    <span class="mz-hint-q">?</span>{{ label }}
  </button>
  <button
    v-else
    type="button"
    class="mz-hint mz-hint-icon"
    :title="title || 'Help'"
    :aria-label="title || 'Help'"
    @click="openHelp(slug, title)"
  >
    ?
  </button>
</template>

<style scoped>
.mz-hint {
  cursor: pointer;
  border: 0;
  background: transparent;
  font-family: inherit;
}
.mz-hint-icon {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #eef2ff;
  color: #4f46e5;
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
}
.mz-hint-icon:hover {
  background: #4f46e5;
  color: #fff;
}
.mz-hint-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
  color: #2a55d6;
  padding: 2px 0;
}
.mz-hint-link:hover {
  text-decoration: underline;
}
.mz-hint-link .mz-hint-q {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #eef2ff;
  color: #4f46e5;
  font-size: 11px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
</style>
